import { graphql } from "api/cms-website/generated";

import { ButtonFragment } from "../primitives/button";
import { ResponsiveImageFragment } from "../primitives/responsiveImage";
import { VerticalListWithImageItemFragment } from "../elements/verticalListWithImageItem";

export const VerticalListWithImageFragment = graphql(/* GraphQL */ `
    fragment VerticalListWithImageFragment on ComponentComponentsVerticalListWithImage {
        id
        noMarginBottom
        verticalListWithImageTitle: title
        verticalListWithImageSubtitle: subtitle
        verticalListWithImageCta: cta {
            ...ButtonFragment
        }
        verticalListWithImageBgImage: bgImage {
            ...ResponsiveImageFragment
        }
        verticalListWithImageItems: items {
            ...VerticalListWithImageItemFragment
        }
        numberedItems
    }
    ${ButtonFragment}
    ${ResponsiveImageFragment}
    ${VerticalListWithImageItemFragment}
`);
